import React from 'react'

import { CommonLogoWithBack, type CommonLogoWithBackProps } from '../CommonLogoWithBack'
import WixLogo from '../icons/WixLogo.svg'
import WixStudioLogo from '../icons/WixStudioLogo.svg'

const getSkinFill = (skin: CommonLogoWithBackProps['skin']) => {
  if (skin === 'light') {
    return '#fff'
  }

  return undefined
}

export type LogoWithBackProps = Omit<CommonLogoWithBackProps, 'logo'> & {
  brand?: 'wix' | 'studio'
  height?: string
  width?: string
}

export const LogoWithBack = (props: LogoWithBackProps) => {
  const { brand = 'wix', skin, height, width } = props
  const fill = getSkinFill(skin)
  const LogoComponent = brand === 'studio' ? WixStudioLogo : WixLogo
  const sizeParams = {
    ...(height && { height }),
    ...(width && { width }),
  }

  return <CommonLogoWithBack {...props} logo={<LogoComponent fill={fill} {...sizeParams} />} />
}
